"use client";

import { motion, useReducedMotion } from "framer-motion";
import { usePortfolioSequence } from "./PortfolioSequence";

export default function PortfolioStars({ active }) {
  const { phase, setPhase } = usePortfolioSequence();
  const reducedMotion = useReducedMotion();
  // Viewport-relative stars radiate from the centre, including on portrait screens.
  const stars = Array.from({ length: 96 }, (_, i) => ({
    x: ((i % 12) + 0.2 + ((i * 37) % 61) / 100) * (100 / 12),
    y: (Math.floor(i / 12) + 0.2 + ((i * 23) % 61) / 100) * (100 / 8),
    size: i % 9 === 0 ? 2 : 1,
  }));

  if (!active || reducedMotion || phase === "done" || phase === "idle") return null;
  return <>
    {phase !== "stars" && <div className="absolute inset-0" data-portfolio-stars>
      {stars.map((star, i) => <span key={i} className="absolute rounded-full bg-white" style={{ left: `${star.x}%`, top: `${star.y}%`, width: star.size, height: star.size, opacity: 0.35 + (i % 5) * 0.13 }} />)}
    </div>}
      {phase === "stars" && !reducedMotion && (
        <motion.div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden" data-portfolio-star-exit
          initial={{ opacity: 1 }} animate={{ opacity: [1, 1, 0] }}
          transition={{ duration: 1.9, times: [0, 0.85, 1] }}
          onAnimationComplete={() => setPhase("done")}>
          {stars.map((star, i) => (
            <motion.span key={i} className="absolute rounded-full bg-white shadow-[0_0_4px_#b9e3ff]"
              style={{ left: `${star.x}%`, top: `${star.y}%`, width: star.size + 0.5, height: star.size + 0.5, opacity: 0.6 + (i % 3) * 0.15 }}
              initial={{ x: 0, y: 0 }}
              animate={{ x: `${(star.x - 50) * 3}vw`, y: `${(star.y - 50) * 3}vh` }}
              transition={{ delay: 0.35, duration: 1.55, ease: [0.55, 0, 0.85, 0.45] }}
            />
          ))}
        </motion.div>
      )}
  </>;
}
